import { PartnerPostsView } from "@/components/partner/PartnerViews";

const PartnerPosts = () => <PartnerPostsView />;

export default PartnerPosts;
